import { Outlet, useLocation } from 'react-router-dom';
import { AppSidebar } from './app-sidebar';
import { Breadcrumb } from '@/components/ui/breadcrumb';
import { useBreadcrumbs } from '@/hooks/use-breadcrumbs';
import { SidebarProvider } from '@/contexts/sidebar-context';

export function AppLayout() {
  const location = useLocation();
  const breadcrumbs = useBreadcrumbs();
  
  // Hide breadcrumbs on home page
  const showBreadcrumbs = location.pathname !== '/';

  return (
    <SidebarProvider>
      <div className="flex h-screen bg-muted/40">
        <AppSidebar />
        <main className="flex-1 overflow-y-auto">
          {showBreadcrumbs && (
            <div className="sticky top-0 z-10 bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60 border-b">
              <div className="px-6 py-3">
                <Breadcrumb items={breadcrumbs} />
              </div>
            </div>
          )}
          <Outlet />
        </main>
      </div>
    </SidebarProvider>
  );
}
